import './harmonicablock.less'

import {m} from '@codeurs/front'
import {ArrowIcon} from 'assets/inline-icons'
import {
	Component,
	Fragment,
	FunctionComponent,
	useEffect,
	useState
} from 'react'
import AnimateHeight from 'react-animate-height'
import {style} from 'util/style'
import {Toggle, ToggleContext} from 'views/partials/toggle'
import {Block, BlockType, renderSwitch} from './blocks'

export type HarmonicaBlockType = {
	content: Array<BlockType>
	title: string
	amount?: string
}

const styles = style('harmonicablock', ['toggler', 'content'])

export const HarmonicaBlock: FunctionComponent<
	HarmonicaBlockType & {defaultOpen?: boolean}
> = ({content, title, defaultOpen = false}) => {
	return (
		<Block class={styles}>
			<Toggle defaultValue={defaultOpen}>
				{({value}) => (
					<Fragment>
						<HarmonicaToggler
							value={value}
							title={title}
							defaultOpen={defaultOpen}
						/>
						<HarmonicaBlocksContent value={value} content={content} />
					</Fragment>
				)}
			</Toggle>
		</Block>
	)
}

export const HarmonicaToggler = ({title, value, defaultOpen}) => {
	const [anchorOpen, setAnchorOpen] = useState<boolean>(defaultOpen)

	useEffect(() => {
		if (!defaultOpen) return
		setAnchorOpen(true)
		setTimeout(() => {
			setAnchorOpen(false)
		}, 300)
	}, [defaultOpen])

	return (
		<ToggleContext.Consumer>
			{({toggle, set}) => {
				if (anchorOpen && !value) {
					set(true)
					setTimeout(() => {
						const preVhash = window.location.hash
						window.location.hash = ''
						window.location.hash = preVhash
					}, 300)
				}
				return (
					<a
						onClick={e => {
							const currentTarget = e.currentTarget
							e.preventDefault()
							toggle()
							currentTarget.scrollIntoView({behavior: 'smooth'})
						}}
					>
						<div class={styles.toggler.is({open: value})}>
							<p class={styles.toggler('title')}>{title}</p>
							<div class={styles.toggler('arrow')}>
								<ArrowIcon class={styles.toggler('arrow-icon')} />
							</div>
						</div>
					</a>
				)
			}}
		</ToggleContext.Consumer>
	)
}

export const HarmonicaBlocksContent: FunctionComponent<{
	content: Array<BlockType>
	value: boolean
}> = props => {
	const {content, value: isOpen} = props
	return (
		content && (
			<div class={styles.content.is({open: isOpen})}>
				<AnimateHeight duration={300} height={isOpen ? 'auto' : 0}>
					<div class={styles.content('container')}>
						{content.map((block, i) => (
							<Fragment key={i}>{renderSwitch(block)}</Fragment>
						))}
					</div>
				</AnimateHeight>
			</div>
		)
	)
}
